import {
  postText,
  queryText
} from '@/axios/util'
import {
  LOGIN,
  USERINFO
} from '@/config/constant'
import {
  getToken,
  setToken,
  removeToken
} from '@/store/getToken'

const user = {
  state: {
    user: '',
    wkIndex: 2,
    status: '',
    loginStatus: 'S',
    userID: '',
    token: getToken(),
    roles: [],
    portrait: '',
    username: '',
    menus: undefined,
    elements: undefined,
    permissionMenus: undefined
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user
      sessionStorage.setItem('user', user)
    },
    SET_WKINDEX: (state, wkIndex) => {
      state.wkIndex = wkIndex
    },
    SET_USERNAME: (state, username) => {
      sessionStorage.setItem('username', username)
      state.username = username
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_LOGINSTATUS: (state, loginStatus) => {
      state.loginStatus = loginStatus
    },
    SET_USERID: (state, userID) => {
      state.userID = userID
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PORTRAIT: (state, portrait) => {
      state.portrait = portrait
    },
    SET_ELEMENTS: (state, elements) => {
      state.elements = elements
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    }
  },
  actions: {
    // 登录
    LoginByUsername ({
      commit
    }, userfrom) {
      return new Promise((resolve, reject) => {
        postText(LOGIN, {
          'username': userfrom.username,
          'password': userfrom.password,
          'wechatCode': userfrom.wechatCode
        }).then(data => {
          commit('SET_LOGINSTATUS', data.status)
          if (data.status === 'S') {
            setToken(data.token)
            commit('SET_USER', data.name)
            commit('SET_USERNAME', userfrom.username)
            // const elements = {}
            // for (let i = 0; i < data.elements.length; i++) {
            //   elements[data.elements[i].code] = true
            // }
            // commit('SET_ELEMENTS', elements)
            // const menus = {}
            // for (let i = 0; i < data.menus.length; i++) {
            //   menus[data.menus[i].code] = true
            // }
            // commit('SET_MENUS', menus)
            resolve()
          } else {
            // $alerts("账号密码不对", "温馨提示", Alert) ;
            //  Message({type:"error",message:"账号密码不对",title:"温馨提示",});
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 拉用户消息
    GetUserInfo ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        sessionStorage.getItem('token')
        queryText(USERINFO, {}).then(response => {
          commit('SET_USER', response.name)
          commit('SET_PORTRAIT', response.avatar)
          commit('SET_USERNAME', response.username)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新工作台的索引的下表
    changeWkIndex ({
      commit
    }, index) {
      commit('SET_WKINDEX', index)
    },
    // 前端 登出
    FedLogOut ({
      commit
    }) {
      return new Promise(resolve => {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('username')
        removeToken()
        sessionStorage.removeItem('jpt-Token')
        commit('SET_ROLES', [])
        commit('SET_USERNAME', '')
        commit('SET_WKINDEX', 2)
        commit('SET_MENUS', undefined)
        commit('SET_ELEMENTS', undefined)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js